module.exports = __webpack_public_path__ + "img/map-message-1.c76dea24.png";